import { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '@store';
import { ResponseError, getResponseErrors } from '@ui/src';
import PermissionColumns from './permission-columns';
import RolesColumn from './roles-column';
import { useLazyGetRolesQuery } from './store/services/roles';

import cn from './styles.module.css';

const Columns = (): React.JSX.Element => {
  const [errorList, setErrorList] = useState('');
  const { roles } = useAppSelector((state) => state.userRoles.roles);
  const [getRoles, { isLoading }] = useLazyGetRolesQuery();

  const getRolesAction = useCallback(async () => {
    const response = (await getRoles('')) as { error?: ResponseError };

    if (response?.error) {
      getResponseErrors({
        error: response?.error,
        setErrorList,
      });
    }
  }, []);

  useEffect(() => {
    if (!roles) {
      getRolesAction();
    }
  }, [getRolesAction, roles]);

  return (
    <>
      {!errorList && (
        <>
          <RolesColumn isLoading={isLoading} />
          <PermissionColumns isLoading={isLoading} />
          <Outlet />
        </>
      )}
      {errorList && (
        <div className={cn.loadingError}>
          <div className={cn.loadingErrorTitle}>Unable to load data</div>
          <div className={cn.loadingErrorText}>{errorList}</div>
        </div>
      )}
    </>
  );
};

export default Columns;
